import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App from './App';
import About from './components/About';
import ArtCategory from './components/ArtCategory';
import ArtList from './components/ArtList';
import Admin from './components/Admin';
import Contact from './components/Contact';

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={ArtList}/>
      <Route path="/about" component={About}/>
      <Route path="/category/:artCategory" component={ArtCategory}/>
      <Route path="/admin" component={Admin}/>
      <Route path="/contact" component={Contact}/>
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js